<template>
  <div :class="drawerClass" @mouseover="drawer = true" @mouseout="drawer = false">
    <v-btn text class="drawer-open-button" @click="drawer = !drawer">
      <v-icon :color="colorHex">fas {{buttonIcon}}</v-icon>
    </v-btn>
    <v-list>
      <v-list-item
        v-for="(image, index) in images"
        :class="tileClass(image)"
        :key="image.imgKey"
        @click="selectImage(image)">
        <v-list-item-content>
          <thumbnail :image="image" :index="index" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import thumbnail from "../misc/Thumbnail";

export default {
  name: "sideBySideImageDrawer",
  components: { thumbnail },
  props: {
    orientation: String,
    context: Object
  },
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    selectImage(image) {
      let isLeft = this.orientation == "left";
      this.$store.dispatch("sideBySideSelectImage", { image, isLeft });
    },
    tileClass(selectedImage) {
      let selected = selectedImage == this.image;
      return (selected ? "selected-image " : "") + "image-tile " + this.colorClass;
    }
  },
  computed: {
    drawerClass() {
      return "image-drawer-wrapper " + this.orientation + (this.drawer ? "" : " closed-drawer");
    },
    buttonIcon() {
      return "fa-caret-" + (this.drawer ? this.orientation : this.otherOrientation);
    },
    otherOrientation(){
      return this.orientation == "left" ? "right" : "left";
    },
    images(){
      return this.context && this.context.images;
    },
    image(){
      return this.context && this.context.image;
    }
  }
};
</script>